<template>
  <div>
    <Header parent="tools">
      <template #title>
        {{ $t("promocodes_table.title") }}
      </template>

      <template #actions>
        <a
          style="text-decoration: none"
          :href="`/api/promocodes/groups/export/${group._id}`"
        >
          <BaseButton variant="secondary" size="md" color="v1-grey-10">
            {{ $t("promocodes_table.export_btn") }}
          </BaseButton>
        </a>
      </template>
    </Header>
    <IQOSTable
      :rows="group.promocodes"
      :cols="[
        {
          title: '#',
          index: true,
          width: 80,
        },
        {
          title: $t('promocodes_table.col_code'),
          key: 'code',
        },
        {
          title: $t('promocodes_table.col_name'),
          key: 'client_name',
          default: '',
        },
        {
          title: $t('promocodes_table.col_phone'),
          key: 'client_phone',
          default: '',
        },
        {
          title: $t('promocodes_table.col_date'),
          key: 'used_at',
        },
        {
          title: $t('promocodes_table.col_status'),
          key: 'status',
        },
      ]"
      v-if="group"
    >
      <template #col-status="slotProps">
        <span class="red-4-color" v-if="slotProps.rowItem.used_at">
          {{ $t("promocodes_table.status_used") }}
        </span>
        <span class="green-5-color" v-else>
          {{ $t("promocodes_table.status_not_used") }}
        </span>
      </template>

      <template #col-used_at="slotProps">
        <span v-if="slotProps.rowItem.used_at">
          {{ slotProps.rowItem.used_at | formatDatetime }}
        </span>
      </template>
    </IQOSTable>
  </div>
</template>


<script>
import IQOS from "@/components/IQOS.vue";

import PromocodesAPI from "@/api/promocodes";

import DashboardButton from "@/components/DashboardButton.vue";

// import ModeIcon from "@/components/ModeIcon.vue"

export default {
  data() {
    return {
      group: null,
    };
  },
  methods: {},
  components: {
    IQOS,
    DashboardButton,
  },
  mounted() {
    PromocodesAPI.getInfo(this.$route.params.id)
      .then((data) => {
        this.group = data.promocode_group;
      })
      .catch((error) => {
        this.$store.dispatch("showError", "promocodes_error");
      });
  },
};
</script>

<style scoped>
</style>
